export default __webpack_public_path__ + "static/media/toast-info.dd2c15c1.svg";